/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { APP_NAME } from "../constants/constants";
import DeleteAccountModal from "./DeleteAccountModal";
// import "../../src/assets/js/app";
// import { baricon1, imguser, logo, noteicon, noteicon1, searchnormal, settingicon01, user06 } from './imagepath';
import {
  logo,
  baricon,
  baricon1,
  imguser,
} from "./imagepath";

const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const handlesidebarmobilemenu = () => {
    document.body.classList.toggle("slide-nav");
    document.getElementsByTagName("html")[0].classList.toggle('menu-opened');
    document.getElementsByClassName("sidebar-overlay")[0].classList.toggle("opened");
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      // Force navigation to login even if logout fails
      navigate('/login');
    }
  };

  const handleAccountDeleted = async () => {
    setShowDeleteModal(false);
    await logout();
    navigate('/login');
  };


  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    const maximizeBtn = document.querySelector(".win-maximize");
    // maximizeBtn.addEventListener('click', handleClick);

    return () => {
      // maximizeBtn.removeEventListener('click', handleClick);
    };
  }, []);
  return (
    <div className="main-wrapper">
      <div className="header">
        <div className="header-left">
          <Link to="/admin-dashboard" className="logo">
            <img src={logo} width={35} height={35} alt="" />{" "}
            <span>{APP_NAME}</span>
          </Link>
        </div>
        <Link id="toggle_btn" to="#" onClick={handlesidebar}>
          <img src={baricon} alt="" />
        </Link>
        <Link id="mobile_btn" className="mobile_btn float-start" to="#" onClick={handlesidebarmobilemenu}>
          <img src={baricon1} alt="" />
        </Link>
        <ul className="nav user-menu float-end">
          <li className="nav-item dropdown has-arrow user-profile-list">
            <Link
              to="#"
              className="dropdown-toggle nav-link user-link"
              data-bs-toggle="dropdown"
            >
              <div className="user-names">
                <h5>{user?.fullName || 'Потребител'}</h5>
                <span>
                  {user?.role === 'ADMIN' ? 'Администратор' :
                   user?.role === 'DOCTOR' ? 'Лекар' :
                   user?.role === 'PATIENT' ? 'Пациент' : 'Служител'}
                </span>
              </div>
              <span className="user-img">
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#2e37a4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}>
                  {user?.firstName?.charAt(0) || 'U'}
                </div>
              </span>
            </Link>
            <div className="dropdown-menu">
              {/* Profile links removed - not implemented */}
              <Link
                to="/change-password"
                className="dropdown-item"
              >
                Промяна на парола
              </Link>
              {user?.role === 'PATIENT' && (
                <button
                  className="dropdown-item text-danger"
                  onClick={() => setShowDeleteModal(true)}
                  style={{ border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer' }}
                >
                  Изтриване на акаунт
                </button>
              )}
              <button
                className="dropdown-item"
                onClick={handleLogout}
                style={{ border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer' }}
              >
                Изход
              </button>
            </div>
          </li>
        </ul>
        <div className="dropdown mobile-user-menu float-end">
          <Link
            to="#"
            className="dropdown-toggle"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            aria-expanded="false"
          >
            <div style={{
              width: '40px',
              height: '40px',
              minWidth: '40px',
              minHeight: '40px',
              borderRadius: '50%',
              backgroundColor: '#2e37a4',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '16px',
              flexShrink: 0
            }}>
              {user?.firstName?.charAt(0) || 'U'}
            </div>
          </Link>
          <div
            className="dropdown-menu dropdown-menu-end mobile-dropdown-fix"
          >
            <Link
              to="/change-password"
              className="dropdown-item"
            >
              Промяна на парола
            </Link>
            {user?.role === 'PATIENT' && (
              <button
                className="dropdown-item text-danger"
                onClick={() => setShowDeleteModal(true)}
                style={{ border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', width: '100%' }}
              >
                Изтриване на акаунт
              </button>
            )}
            <button
              className="dropdown-item"
              onClick={handleLogout}
              style={{ border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', width: '100%' }}
            >
              Изход
            </button>
          </div>
        </div>
      </div>

      <DeleteAccountModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDeleted={handleAccountDeleted}
      />
    </div>
  );
};

export default Header;
